exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".collapsed-card .card-header{border-bottom:0}", "", {"version":3,"sources":["/var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/property-lookup-form/property-lookup-form.component.css"],"names":[],"mappings":"AAAA,6BACI,eAAiB,CACpB","file":"property-lookup-form.component.css","sourcesContent":[".collapsed-card .card-header {\n    border-bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/property-lookup-form/property-lookup-form.component.css
// module id = RYae
// module chunks = 0